export const TIME_FIELD_INVENTORY = {
  CREATED: 'createdTime',
  CONFIRMED: 'confirmedTime',
  PREPARING: 'packingTime',
  CHECK_PACKAGE: 'checkPackageTime',
  FINISH_TIME: 'finishTime',
  IN_PACKAGE: 'inPackage',
  WAITING_PAY: 'waitingPay',
  SUCCESSFUL_PAY: 'successfulPay',
  WAITING_EXPORT_VAT: 'waitingExportVAT',
  TO_SHIPPER: 'toShipper',
  SUCCESSFUL_EXPORT_VAT: 'successfulExportVAT',
}

export const TIME_FIELD_TITLE_INVENTORY = {
  [TIME_FIELD_INVENTORY.CREATED]: 'Vừa đặt',
  [TIME_FIELD_INVENTORY.CONFIRMED]: 'Xác nhận',
  [TIME_FIELD_INVENTORY.PREPARING]: 'Soạn hàng',
  [TIME_FIELD_INVENTORY.CHECK_PACKAGE]: 'Kiểm hàng',
  [TIME_FIELD_INVENTORY.FINISH_TIME]: 'Hoàn thành',
  [TIME_FIELD_INVENTORY.IN_PACKAGE]: 'Đóng gói',
  [TIME_FIELD_INVENTORY.WAITING_PAY]: 'Chưa thanh toán',
  [TIME_FIELD_INVENTORY.SUCCESSFUL_PAY]: 'Đã thanh toán',
  [TIME_FIELD_INVENTORY.WAITING_EXPORT_VAT]: 'Chờ xuất hoá đơn',
  [TIME_FIELD_INVENTORY.SUCCESSFUL_EXPORT_VAT]: 'Xuất hoá đơn thành công',
  [TIME_FIELD_INVENTORY.TO_SHIPPER]: 'Đã giao hàng',
}

export const SCAN_TYPE = {
  DUPLICATE: 'DUPLICATE',
  CHANGE_STATUS_ERROR: 'CHANGE_STATUS_ERROR',
}

export const STATUS = {
  DRAFT: "DRAFT",
  CREATED: "CREATED",
  CONFIRMED: "CONFIRMED",
  PREPARING: "PREPARING",
  CHECK_PACKAGE: "CHECK_PACKAGE",
  IN_PACKAGE: "IN_PACKAGE",
  DELIVERING: "DELIVERING",
  FINISHED: "FINISHED",
  WAIT_CUSTOMER_PICK_UP: "WAIT_CUSTOMER_PICK_UP",
  WAITING_PAY: "WAITING_PAY",
  WAITING_EXPORT_VAT: "WAITING_EXPORT_VAT",
  SUCCESSFUL_EXPORT_VAT: "SUCCESSFUL_EXPORT_VAT",
  CANCELED: "CANCELED"
};



export const STATUS_TITLE = {
  DRAFT: "Đơn nháp",
  CREATED: "Vừa đặt",
  CONFIRMED: "Xác nhận",
  PREPARING: "Soạn hàng",
  CHECK_PACKAGE: "Kiểm hàng",
  IN_PACKAGE: "Đóng gói ",
  DELIVERING: "Giao hàng",
  WAIT_CUSTOMER_PICK_UP: "Khách đến lấy",
  WAITING_PAY: "Chờ thanh toán",
  WAITING_EXPORT_VAT: "Chờ xuất HĐ",
  SUCCESSFUL_EXPORT_VAT: "Đã xuất HĐ",
  FINISHED: "Hoàn thành",
  CANCELED: "Đơn bị huỷ",
};
// Chỉ các tài khoản có email này mới được vào trang QLNViên
export const ACCOUNT_MANAGER_EMAILS = [
  'vanphongphamtantien@gmail.com',
];

export const isAccountManager = (user) =>
  ACCOUNT_MANAGER_EMAILS.includes(`${user?.email || ''}`.trim().toLowerCase());

export const STOREFRONT_URL = process.env.REACT_APP_STOREFRONT_URL || 'https://trungtamvanphongpham.vn';
